import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as franchiseInitialState, HANDLERS as franchiseHandler } from "../../../components/desktop/franchise/reducers";
export default {
    [reducerConstants.FRANCHISE]: { state: franchiseInitialState, handler: franchiseHandler }
};
